export const handleChangeInputRadioDinamic = (e, id, action, values) => {
  const targetId  = e.target.id;
	const value     = e.target.value;
	const name      = e.target.name;
  const array     = name.split("#");

  values.values[array[1]][array[0]] = value;
	
	action(values, id, targetId, true);
};


// WEBPACK FOOTER //
// src/helpers/lib/handleChangeInputRadioDinamic.js